<template>
	<Transition>
		<div class="toast">
			<div
				class="content"
			>
				<div class="message">
					{{ message }}
				</div>
				<span
					class="close"
					@click.stop="onClose"
				>
					<Icon
						icon-name="e-remove"
						size="sm"
						class="close-icon"
					/>
				</span>
			</div>
		</div>
	</Transition>
</template>

<script>
export default {
	name:  'PlayerErrorSnackbar',
	props: {
		message: {
			type:     String,
			required: true,
		},
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
	},

};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.toast {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 6px 8px;
	background-color: var(--color-grey-800);
	color: var(--color-soft-white);
	border-radius: 2px;
	box-shadow: 0 9px 12px rgba(0, 0, 0, 0.14), 0 3px 16px rgba(0, 0, 0, 0.12), 0 5px 6px rgba(0, 0, 0, 0.2);

	body.-t-light & {
		background-color: var(--color-grey-200);
	}

	@include size(sm-up) {
		padding: 6px 16px;
	}

	.content {
		@include text-sm-1;
		display: flex;
		align-items: center;
		width: 100%;

		@include size(sm-up) {
			@include text-sm-2;
		}
	}

	.message {
		position: relative;
		flex: 1 0 0;
		text-overflow: clip;
		white-space: nowrap;
		overflow: hidden;
		margin-right: 8px;
		font-size: inherit;

		@include size(sm-up) {
			margin-right: 16px;
		}
	}

	.close {
		@include text-sm-1;
		justify-self: flex-end;
		text-decoration: none;
		color: var(--color-hype-yellow);
		cursor: pointer;
		@include size(sm-up) {
			@include text-sm-2;
		}
	}
}

.v-enter-active {
	transition: all 0.2s linear;
}

.v-leave-active {
	transition: all 0.5s ease-out;
}

.v-enter,
.v-leave {
	transform: translateY(40px);
	opacity: 0;
}
</style>
